<script setup lang="ts">
withDefaults(defineProps<{
  loading: boolean;
  error: Error | null;
  empty?: boolean;
  retry?: () => void | Promise<void>;
}>(), { empty: false });

defineSlots<{
  default?: () => unknown;
  loading?: () => unknown;
  error?: (props: { error: Error; retry: () => void | Promise<void> }) => unknown;
  empty?: () => unknown;
}>();
</script>

<template>
  <div v-if="loading" class="async-state state-msg" role="status" aria-live="polite">
    <slot name="loading"><p>กำลังโหลด…</p></slot>
  </div>
  <div v-else-if="error" class="async-state state-msg" role="alert">
    <slot name="error" :error="error" :retry="retry ?? (() => undefined)">
      <div class="state-msg__icon">!</div>
      <p>โหลดข้อมูลไม่สำเร็จ</p>
      <button type="button" class="async-state__retry" @click="retry?.()">ลองใหม่</button>
    </slot>
  </div>
  <div v-else-if="empty" class="async-state state-msg">
    <slot name="empty"><p>ยังไม่มีข้อมูล</p></slot>
  </div>
  <slot v-else />
</template>

<style scoped>
 .async-state__retry { margin-top: .5rem; padding: .35rem .7rem; border: 1px solid var(--line); border-radius: var(--radius-badge); background: var(--surface-2); color: inherit; cursor: pointer; }
</style>
